import { textStyle } from '@themes/mixins';
import styled from 'styled-components';

export const Root = styled.div``;
export const ValidationHeaderError = styled.div`
  ${textStyle({
    color: 'textWhite',
    lineHeight: 1,
    size: '14px',
    weight: 500,
    textAlign: 'left',
  })};
  margin-top: 10px;
`;
export const ValidationErrorText = styled.div`
  ${textStyle({
    color: 'textWhite',
    lineHeight: 1.3,
    size: '13px',
    weight: 400,
    textAlign: 'left',
  })};
  padding-left: 16px;
`;
export const ValidationErrorTitle = styled.span`
  ${textStyle({
    color: 'textWhite',
    lineHeight: 1.3,
    size: '13px',
    weight: 500,
    textAlign: 'left',
  })};
  text-decoration: underline;
`;
